import { type ForwardedRef } from "react";

import { type ScatterDataPoint } from "chart.js";
import { Line } from "react-chartjs-2";

import type {
  ChartJSOrUndefined,
  ChartProps,
} from "react-chartjs-2/dist/types";

export type BarOrLine = "bar" | "line";

type MixedChartType = <
  TData = (number | ScatterDataPoint | null)[],
  TLabel = unknown,
>(
  props: Omit<ChartProps<BarOrLine, TData, TLabel>, "type"> & {
    ref?:
      | ForwardedRef<ChartJSOrUndefined<BarOrLine, TData, TLabel>>
      | undefined;
  },
) => JSX.Element;

export const MixedChart = Line as MixedChartType;
